import axios, { AxiosRequestConfig } from 'axios'

const DEFAULT_API_URL = 'http://localhost:3333/api/v1'

export const getApiUrl = () => process.env.REACT_APP_API_URL || DEFAULT_API_URL

export const toApiUrl = (pathOrUrl: string) => {
  if (/^https?:\/\//i.test(pathOrUrl)) {
    const url = new URL(pathOrUrl)

    return `${getApiUrl()}${url.pathname}${url.search}${url.hash}`
  }

  if (pathOrUrl.startsWith('/')) {
    return `${getApiUrl()}${pathOrUrl}`
  }

  return `${getApiUrl()}/${pathOrUrl}`
}

const instance = axios.create({
  baseURL: getApiUrl(),
})

export const get = async (url: string, params?: AxiosRequestConfig<any>) => {
  const response = await instance.get(url, params)

  return response.data
}

export const getWithAuth = async (
  url: string,
  config?: AxiosRequestConfig<any>
) => {
  const token = localStorage.getItem('token')

  if (!token) {
    throw new Error('Token not found')
  }

  const response = await instance.get(url, {
    ...config,
    headers: {
      Authorization: `Bearer ${token}`,
      ...config?.headers,
    },
  })

  return response.data
}

export const post = async (
  url: string,
  data?: any,
  config?: AxiosRequestConfig<any>
) => {
  const response = await instance.post(url, data, config)

  return response.data
}

export const postWithAuth = async (
  url: string,
  data?: any,
  config?: AxiosRequestConfig<any>
) => {
  const token = localStorage.getItem('token')

  if (!token) {
    throw new Error('Token not found')
  }

  const response = await instance.post(url, data, {
    ...config,
    headers: {
      Authorization: `Bearer ${token}`,
      ...config?.headers,
    },
  })

  return response.data
}

export const put = async (url: string, data?: any) => {
  const response = await instance.put(url, data)

  return response.data
}

export const patch = async (url: string, data?: any) => {
  const response = await instance.patch(url, data)

  return response.data
}

export const del = async (url: string) => {
  const response = await instance.delete(url)

  return response.data
}
